import request from '@/utils/request'

/**
 * 用户信息
 * @param {*} data
 */
export function systemUserInfoAPI(data) {
  return request({
    url: 'adminUser/queryUserInfo',
    method: 'post',
    data: data
  })
}

/**
 * 下载
 * @param url
 */
export function downloadFileAPI(url) {
  return request({
    url: url,
    method: 'post',
    data: {},
    responseType: 'blob'
  })
}

/**
 * 记录菜单访问信息
 * @param data
 */
export function saveMenuVisitRecordAPI(data) {
  return request({
    url: '/web/service?method=tCoreMenuVisitRecord_save',
    method: 'post',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/api/common.js